import OddButton from '../match/odd_button';
import { useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { AWS_BUCKET_URL } from '../../toolkit/constants';
import { useLocation } from 'react-router-dom';
import { OddsValueTypeTextCreator } from 'toolkit/utils';
import { EnumMarketName } from 'toolkit/Enums';

function BetBox(props) {
  const { providerId, marketStringId, outcomeId } = props;
  const producerStatus = useSelector((state) => state.match.producerStatus);
  const match = useSelector((state) => state.match.events[providerId]);
  const [path, setPath] = useState('');
  const location = useLocation();
  const nonTitledMarkets = [
    EnumMarketName.ANYTIMEGOALSCORER_40,
    EnumMarketName.NEXTGOALSCORER_38,
    EnumMarketName.LASTGOALSCORER_39
  ];

  // Derived during render (not through an effect) so the first painted frame is
  // already correct - computing this in an effect made the button render one
  // frame with the wrong state.
  const { betTitle, disabled } = useMemo(() => {
    const market = match?.markets?.find((m) => m.stringId === props.marketStringId);
    const outcome = market?.outcomes?.find((o) => o.id === props.outcomeId);
    const isDisabled =
      market?.marketStatus !== 6 ||
      (market?.producer === 1 && producerStatus.preMatch === false) ||
      (market?.producer === 2 && producerStatus.live === false);

    let title = '';
    try {
      if (!nonTitledMarkets.includes(market?.id)) {
        title = OddsValueTypeTextCreator(
          match?.sport?.toString(),
          market?.id?.toString(),
          outcome?.id,
          outcome?.name
        );
      }
    } catch (error) {
      console.log(error);
    }

    return { betTitle: title, disabled: isDisabled };
  }, [match, props.marketStringId, props.outcomeId, producerStatus.live, producerStatus.preMatch]);

  useEffect(() => {
    setPath(location.pathname);
  }, [location]);

  if (disabled)
    return (
      <div className="button-class">
        {location.pathname === '/match-detail' && <span>{betTitle}</span>}
        <div className={`justify-content-center w-100 px-1 text-center text-muted light-black-svg 
        ${props.betBox === undefined || props.betBox === '' ? 'betOddsBox' : props.betBox}
        `}>
          <img width="20" height="16" src={`${AWS_BUCKET_URL}/Icons/lockicon.svg`} />
        </div>
      </div>
    );

  return (
    <>
      {props.showOddTitle && location.pathname === '/match-detail' && (
        <div className="button-class">
          <span>{betTitle}</span>
        </div>
      )}
      <OddButton
        providerId={props.providerId}
        outcomeId={props.outcomeId}
        marketStringId={props.marketStringId}
        betBox={props.betBox}
      />
    </>
  );
}

BetBox.defaultProps = {
  showOddTitle: true
};

export default BetBox;
